export default __webpack_public_path__ + "static/media/img_step_lucia03-04.45960096.jpg";